// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import Util from "PreciateUtil";

export default interface SocialAdmitted {
    admitted?: boolean;
    banned?: boolean;
    admittedDateTime?: Date;
    bannedDateTime?: Date;
}

export function processSocialAdmitted(value?: SocialAdmitted): void {
  if (value) {
    value.admittedDateTime = Util.toDate((value as any).admittedDateTime);
    value.bannedDateTime = Util.toDate((value as any).bannedDateTime);
  }
}

export function processSocialAdmittedArray(array?: SocialAdmitted[]): void {
  if (array) {
    for (const v of array) {
      processSocialAdmitted(v);
    }
  }
}
